
    <template>
    <svg viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.0834 10.818V14.5834H13.3334V12.083H12.0834V17.1413H10.8334V10.8334H14.5834V13.333H15.8334V10.818H17.0834ZM9.16675 10.8334V17.0834H2.91675V10.8334H9.16675ZM17.0834 15.8334V17.0834H13.3334V15.8334H17.0834ZM7.91675 12.0834H4.16675V15.8334H7.91675V12.0834ZM6.66675 13.3334V14.5834H5.41675V13.3334H6.66675ZM9.16675 2.91675V9.16675H2.91675V2.91675H9.16675ZM17.0834 2.91675V9.16675H10.8334V2.91675H17.0834ZM7.91675 4.16675H4.16675V7.91675H7.91675V4.16675ZM15.8334 4.16675H12.0834V7.91675H15.8334V4.16675ZM6.66675 5.41675V6.66675H5.41675V5.41675H6.66675ZM14.5834 5.41675V6.66675H13.3334V5.41675H14.5834Z" fill="currentColor"/>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Qrcode',
    }) as DefineComponent
    </script>
    